import React, { useState } from 'react';
import { Form, Input, Radio, Button, message, Modal } from 'antd';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useForm } from 'antd/lib/form/Form';
import ds from '../../../Services/DataServices';
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices';
import { StringIsNullOrEmpty } from '../../../appRedux/actions';

const { Item } = Form;

const AdjustPriceBookPrices = (params) => {
  const history = useHistory();
  const [form] = useForm();
  const [visible, setVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false); // New state for confirmation modal
  const [loading, setLoading] = useState(false); // State for loading button
  const priceBookID = params && params.PriceBookID;

  const showModal = () => {
    if (!StringIsNullOrEmpty(priceBookID)) {
      setVisible(true);
    } else {
      message.error('Pricebook id should not be empty');
    }
  };

  const handleCancel = () => {
    setVisible(false);
    setConfirmVisible(false); // Hide confirmation modal if cancel is clicked
  };

  const handleConfirmOk = async () => {
    form.submit(); // Submit the form when user confirms
  };

  const onFinish = async (values) => {
    try {
      setLoading(true); // Set loading state to true
      let postObj = {
        PriceBookID: priceBookID,
        ...values,
      };
      await postAdjustPriceBookPrices(postObj, BEHAVIOUR_TYPE.POST);
    } catch (error) {
      message.error('Failed to submit form!');
      console.error('API Error:', error);
    } finally {
      setLoading(false); // Reset loading state after API call completes
      setConfirmVisible(false); // Hide confirmation modal after submission
    }
  };

  async function postAdjustPriceBookPrices(body, behaviorType) {
    try {
      const res = await ds.postAdjustPricesPriceBook(body, behaviorType);

      if (!res || !res.data) {
        throw new Error('Invalid response from server. Pricebook adjustment failed.');
      }

      if (res.data.msgCode === 'GENERAL_SUCCESS') {
        const priceBookURL = `/Dashboard/products/pricebook/customprices/${res.data.data.priceBookID}`;
        setVisible(false);
        message.success(res.data.data.message);
        setTimeout(() => {
          window.location.href = priceBookURL; // Redirect after success
        }, 1000);
      } else {
        throw new Error('Pricebook adjustment failed. Something went wrong.');
      }
    } catch (error) {
      message.error(error.message || 'Pricebook adjustment failed. Something went wrong.');
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleDecimalChange = (e) => {
    const { value } = e.target;
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      form.setFieldsValue({ value });
    }
  };

  return (
    <>
      <div className="pg-header-btn">
        <Modal
          title={'Are you sure you want to adjust prices for all products in this pricebook ?'}
          visible={visible && !confirmVisible} // Hide the form modal when confirmation modal is visible
          onCancel={handleCancel}
          centered={true}
          className="ProductTags-Modal"
          footer={
            <>
              <Button className="dk-btn-cancel" type="primary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="dk-btn-add"
                type="primary"
                loading={loading} // Bind loading state to the button
                onClick={() => setConfirmVisible(true)} // Show confirmation modal
              >
                Confirm
              </Button>
            </>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ action: 'Add' }}
            onFinishFailed={onFinishFailed}
            id="addATagForm"
          >
            <Item
              name="action"
              label="Action"
              rules={[{ required: true, message: 'Please select an action!' }]}
            >
              <Radio.Group>
                <Radio value="Add">Add</Radio>
                <Radio value="Reduce">Reduce</Radio>
                <Radio value="FixedPrice">Fixed Price</Radio>
              </Radio.Group>
            </Item>

            <Item
              name="value"
              label="Value"
              rules={[{ required: true, message: 'Please input a decimal value!' },    { pattern: /^\d*\.?\d*$/, message: 'Only numeric values are allowed!' }]}
            >
              <Input onChange={handleDecimalChange} />
            </Item>
          </Form>
        </Modal>

        <Modal
          title="Confirmation"
          visible={confirmVisible}
          onCancel={handleCancel}
          centered={true}
          footer={
            <>
              <Button className="dk-btn-cancel" type="primary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="dk-btn-add"
                type="primary"
                loading={loading} // Bind loading state to the button
                onClick={handleConfirmOk}
              >
                OK
              </Button>
            </>
          }
        >
          Are you sure you want to change the product prices for this pricebook? This action is not <span style={{color :"#FF5E5E"}}>reversible</span> .
        </Modal>

        <Button className="dk-btn-add" type="primary" onClick={showModal} size="large">
          Adjust Retail Prices
        </Button>
      </div>
    </>
  );
};

export default AdjustPriceBookPrices;
  